module.exports = __webpack_public_path__ + "static/media/wavy_left.594033f6.svg";